import { isImageFile, isOpenAPIFile } from '@gitbook/app-database';
import type * as hiveCore from '@gitbook/hive-core';

const ONE_KB = 1024;
const ONE_MB = ONE_KB * 1024;

/**
 * Return a file size as human readable formatted string.
 */
export function getHumanFileSize(size: number): string {
    if (size > ONE_MB) {
        const mbSize = size / ONE_MB;
        return `${mbSize.toFixed(0)}MB`;
    }
    if (size > ONE_KB) {
        const kbSize = size / ONE_KB;
        return `${kbSize.toFixed(0)}KB`;
    }

    return `${size}B`;
}

/**
 * Return a user friendly file type from the contentType
 */
export function getFileType(file: hiveCore.RevisionFile) {
    if (isImageFile(file)) {
        return 'Image';
    }

    if (isOpenAPIFile(file)) {
        return 'Code';
    }

    if (file.contentType === 'application/pdf') {
        return 'PDF';
    }

    if (file.contentType.startsWith('text/')) {
        return 'Text';
    }

    return 'Binary';
}
